export const entitiesSummary = {
  unifiedPerson: {
    default: ['cidadão', 'cidadãos'],
    agsus: ['profissional', 'profissionais'],
  },
  publicAgent: {
    default: ['agente público', 'agentes públicos'],
    agsus: ['usuário do sistema', 'usuários do sistema'],
  },
}
